import React from 'react';

export function createClickHandler(
  onClick: () => void,
): React.MouseEventHandler<HTMLElement> {
  return (event) => {
    if (!event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
      event.preventDefault();
      onClick();
    }
  };
}
